import { getAutopayApplicationPath } from '../autopay/getAutopayApplicationPath';

/**
 * The Consumer Portal application path uses the same endpoint naming convention as the Autopay application
 *
 * Here we assign the Autopay application path to the Consumer Portal path
 * This was done in order to keep the naming conventions consistent when refering to Consumer Portal network requests
 */
export const getConsumerPortalApplicationPath = getAutopayApplicationPath;
